/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ seconds: NonNullable<unknown> }} Signin_Resend_ReasonInputs */

const en_signin_resend_reason = /** @type {(inputs: Signin_Resend_ReasonInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`You can resend the link in ${i?.seconds} seconds.`)
};

/**
* | output |
* | --- |
* | "You can resend the link in {seconds} seconds." |
*
* @param {Signin_Resend_ReasonInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const signin_resend_reason = /** @type {((inputs: Signin_Resend_ReasonInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Signin_Resend_ReasonInputs, { locale?: "en" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_signin_resend_reason(inputs)
});